(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["strangewood-footer-trails-end"] && !Shopify.designMode) return;
  try {
    
(function () {
  function enhance(root) {
    root.querySelectorAll('form.swt-form').forEach((form) => {
      if (form.dataset.inlineSignupReady || form.hasAttribute('data-hcaptcha-bound')) return;
      const button = form.querySelector('button[type="submit"]');
      const email = form.querySelector('input[type="email"]');
      if (!button || !email || typeof form.submit !== 'function') return;

      let message = form.querySelector('.swt-msg');
      if (!message) {
        message = document.createElement('p');
        message.id = 'SwtMsg-' + form.id;
        message.className = 'swt-msg';
        message.hidden = true;
        form.append(message);
      }
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      message.setAttribute('aria-atomic', 'true');
      email.setAttribute('aria-describedby', message.id);

      const nativeSubmit = form.submit.bind(form);
      const originalLabel = button.textContent;
      let pending = false;
      let sending = false;
      let timer;
      let controller;

      function finish(text, isError) {
        clearTimeout(timer);
        pending = false;
        form.removeAttribute('aria-busy');
        button.removeAttribute('aria-disabled');
        button.textContent = originalLabel;
        message.textContent = text;
        message.className = 'swt-msg ' + (isError ? 'swt-msg--err' : 'swt-msg--ok');
        message.hidden = !text;
      }

      function fail(text) {
        form.dataset.inlineSignupReady = 'fallback';
        finish(text || form.dataset.failureText, true);
      }

      function begin() {
        if (pending) return;
        pending = true;
        form.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-disabled', 'true');
        button.textContent = form.dataset.pendingText;
        message.hidden = true;
        message.textContent = '';
        timer = setTimeout(() => {
          if (!pending) return;
          controller?.abort();
          fail();
        }, 60000);
      }

      form.submit = async function submitVerifiedSignup() {
        if (sending) return;
        const token = form.elements.namedItem('h-captcha-response');
        if (form.dataset.inlineSignupReady !== 'ajax' || !form.hasAttribute('data-hcaptcha-bound') || !token?.value) {
          nativeSubmit();
          return;
        }
        const action = new URL(form.action, window.location.href);
        if (action.origin !== window.location.origin) {
          nativeSubmit();
          return;
        }
        sending = true;
        begin();
        controller = new AbortController();
        try {
          const response = await fetch(action.href, {
            method: 'POST',
            body: new FormData(form),
            credentials: 'same-origin',
            headers: { Accept: 'text/html' },
            signal: controller.signal
          });
          const destination = new URL(response.url);
          if (destination.origin === window.location.origin && /\/challenge\/?$/.test(destination.pathname)) {
            finish(form.dataset.verificationText, false);
            window.location.assign(destination.href);
            return;
          }
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const responseForm = doc.getElementById(form.id);
          const success = responseForm?.querySelector('.swt-msg--ok');
          const error = responseForm?.querySelector('.swt-msg--err');
          if (response.ok && success?.textContent.trim()) {
            finish(success.textContent.trim(), false);
            email.value = '';
            email.removeAttribute('aria-invalid');
            form.dataset.inlineSignupReady = 'subscribed';
            button.disabled = true;
            button.textContent = form.dataset.subscribedText;
            email.readOnly = true;
          } else {
            fail(error?.textContent.trim());
          }
        } catch {
          fail();
        } finally {
          sending = false;
          controller = null;
        }
      };

      form.addEventListener('submit', () => {
        if (form.dataset.inlineSignupReady === 'ajax') begin();
      }, true);
      button.addEventListener('click', (event) => {
        if (pending) event.preventDefault();
      });
      email.addEventListener('keydown', (event) => {
        if (pending && event.key === 'Enter') event.preventDefault();
      });
      form.dataset.inlineSignupReady = 'ajax';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhance(document), { once: true });
  } else {
    enhance(document);
  }
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
